import { UserRoles } from '@anytag/graphql';

import { refineBasedOnRoleSchema } from '../schema';
import { MarketplaceFormKeys } from '../types';

export const getUrlTrackingFormSchema = (role: UserRoles) =>
  refineBasedOnRoleSchema(role, {
    [MarketplaceFormKeys.title]: true,
    [MarketplaceFormKeys.minAge]: true,
    [MarketplaceFormKeys.maxAge]: true,
    [MarketplaceFormKeys.budget]: true,
    [MarketplaceFormKeys.period]: true,
    [MarketplaceFormKeys.genders]: true,
    [MarketplaceFormKeys.clickUrl]: true,
    [MarketplaceFormKeys.countryId]: true,
    [MarketplaceFormKeys.thumbnails]: true,
    [MarketplaceFormKeys.marginRate]: true,
    [MarketplaceFormKeys.socialMedia]: true,
    [MarketplaceFormKeys.requirement]: true,
    [MarketplaceFormKeys.salesPicIds]: true,
    [MarketplaceFormKeys.advertiserId]: true,
    [MarketplaceFormKeys.minFollowers]: true,
    [MarketplaceFormKeys.maxFollowers]: true,
    [MarketplaceFormKeys.preLaunchDate]: true,
    [MarketplaceFormKeys.landingPageUrl]: true,
    [MarketplaceFormKeys.campaignCategoryId]: true,
    [MarketplaceFormKeys.serviceInformation]: true,
    [MarketplaceFormKeys.influencerCategoryIds]: true,
    [MarketplaceFormKeys.influencerManagementPicIds]: true,
    [MarketplaceFormKeys.costPerClick]: true,
    [MarketplaceFormKeys.costPerAction]: true,
    [MarketplaceFormKeys.costPerSaleTune]: true,
    [MarketplaceFormKeys.postTrackingEndDate]: true
  });
